import { Hero } from "@/sections/Hero";
import { Manifesto } from "@/sections/Manifesto";
import { AboutAyush } from "@/sections/AboutAyush";
import { ToolsPreview } from "@/sections/ToolsPreview";
import { FeatureGrid } from "@/sections/FeatureGrid";
import { QuotesCarousel } from "@/sections/QuotesCarousel";
import { FaqSection } from "@/sections/FaqSection";
import { ContactSection } from "@/sections/ContactSection";
import { Marquee } from "@/components/Marquee";

export default function Home() {
  return (
    <>
      <Hero />
      <Manifesto />
      <Marquee items={["Smart Buyer", "Data-Driven", "Zero Jargon", "First-Time Ready", "Integrity"]} />
      <ToolsPreview />
      <AboutAyush />
      <FeatureGrid />
      <QuotesCarousel />
      <FaqSection />
      <ContactSection />
    </>
  );
}
